import execute_on from "../../libs/execute-on";
import hideVat from "../../plugins/hide-vat-outside-ue/hide-vat-outside-ue"

execute_on('users.register-step2', function () {
    hideVat("select2-country-mf-container");
});

